import { GREEN, ORANGE, RED } from 'components/gauge';
export const BRAINFUNCTION_LEGEND_OPTIONS = [
  {
    color: RED,
    text: 'Extremely affected'
  },
  {
    color: ORANGE,
    text: 'Significantly affected'
  },
  {
    color: 'rgb(237, 225, 22)',
    text: 'Affected'
  },
  {
    color: GREEN,
    text: 'Within normal range'
  }
] as const;

export function Legend() {
  return (
    <div
      style={{
        overflow: 'hidden',
        borderRadius: 12
      }}
    >
      {BRAINFUNCTION_LEGEND_OPTIONS.map(option => (
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 12 }}
          key={option.color}
        >
          <div
            style={{
              width: '30px',
              height: '30px',
              background: option.color
            }}
          />
          <div>{option.text}</div>
        </div>
      ))}
    </div>
  );
}
